import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=073a23a0&scoped=true&"
import script from "./refund.vue?vue&type=script&lang=js&"
export * from "./refund.vue?vue&type=script&lang=js&"
import style0 from "./refund.vue?vue&type=style&index=0&id=073a23a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073a23a0",
  null
  
)

export default component.exports